/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Event = new Vue();

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import {Datetime} from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'
import {Settings} from 'luxon'
//import VueSweetalert2 from 'vue-sweetalert2';
//import Multiselect from 'vue-multiselect'
//import vueCountryRegionSelect from 'vue-country-region-select'
//import 'vue-multiselect/dist/vue-multiselect.min.css';
import VueI18n from 'vue-i18n'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueTelInput from 'vue-tel-input'


import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2)

import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

Vue.use(VueTelInput)

window.normalizeUrl = require('normalize-url');

Settings.defaultLocale = window.default_locale;
import accounting from 'accounting-js';

accounting.settings = {
    thousand: '',
    decimal: ',', // decimal point separator
}
Object.defineProperty(Vue.prototype, '$accounting', {value: accounting});

//Vue.component('multiselect', Multiselect)
Vue.use(VueI18n)
//Vue.use(VueSweetalert2)

Vue.component('v-select', vSelect)
Vue.component('datetime', Datetime);


//Vue.use(vueCountryRegionSelect)
// import plugin
import VueToastr from "vue-toastr";



Vue.mixin({
    methods: {
        route: (name, params, absolute) => route(name, params, absolute, Ziggy),
    }
});

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading, {
    color: '#008DD2',
    width: 200,
    height: 200,
});
//
// import Toasted from 'vue-toasted';
// Vue.use(Toasted)

// use plugin
Vue.use(VueToastr, {defaultTimeout: 2000});

Vue.component('total', require('./components/order/TotalComponent.vue').default);
Vue.component('registration-test', require('./components/OrderComponent.vue').default);
Vue.component('registration-custom', require('./components/OrderComponentCustom.vue').default);
Vue.component('registration-vip', require('./components/OrderComponentVip.vue').default);
Vue.component('registration-race-change', require('./components/OrderComponentRaceChange.vue').default);
Vue.component('registration-waiting-list', require('./components/OrderComponentWaitingList.vue').default);
Vue.component('registration-run', require('./components/OrderComponentRun.vue').default);
Vue.component('registration-josipov-dom', require('./components/OrderComponentJosipovDom.vue').default);

Vue.component('checkout', require('./components/CheckoutComponent.vue').default);
Vue.component('coupon', require('./components/order/CouponComponent.vue').default);
Vue.component('race-results', require('./components/RaceResultCheckComponent').default);
Vue.component('volunteers', require('./components/VolunteersRegistrationComponent.vue').default);
Vue.component('kids-order', require('./components/KidsOrderComponent.vue').default);
Vue.component('newsletter', require('./components/NewsletterComponent.vue').default);
Vue.component('gtm-event', require('./components/GtmEventComponent.vue').default);


//window.Vue = require('vue');

//Vue.prototype.$eventHub = new Vue(); // Global event bus
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//Vue.component('product-price', require('./components/ProductPriceComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

//Vue.config.devtools = true

const messages = {
    en: {

        notification: {
            title: 'IMPORTANT UPDATE:',
            description: 'Runners lists available, important update regarding COVID certificates',
            read_more: 'READ MORE...',
            url: '/news/runners-lists-available-important-covid-19-update',
             url2: '/news/runners-lists-available-important-covid-19-update'
        },


        registration: {
            euro: "Registrations are closed  due to the conversion to euro. We'll be back soon!",
            kids_7_9: "Kid's Day (7-9 years)",
            kids_9_11: "Kid's Day (9-11 years)",
            kids_12_14: "Kid's Day (12-14 years)",
            first_name: 'First name',
            last_name: 'Last name',
            date_of_birth: 'Date of birth',
            gender: 'Gender',
            male: 'Male',
            female: 'Female',
            state: 'Country',
            address: 'Address',
            city: 'City',
            postal: 'Zip code',
            shirt_size: 'Shirt size',
            club_name: 'Club / School / Kindergarten',
            emergency_contact: 'Emergency contact number',
            emergency_contact_name: 'Emergency contact name',
            email: 'Email',
            country_code: 'Country code',
            phone: 'Phone',
            chose_ticket: 'Chose package',
            arrival_date: 'Date of arrival',
            departure_date: 'Date of departure',
            transport: 'Way of transportation',
            accomodation: 'Accomodation type',
            passengers: 'Number of travel companions',
            note: 'Reference',
            register: 'Register Now',
            racer: 'FOR RUNNER',
            no: 'NO.',
            remove: 'Remove',
            selected: 'SELECTED',
            select: 'SELECT',
            package: 'PACKAGES',
            add_racer: 'Add runner',
            parent_name: 'Parent name',
            parent_lastname: 'Parent last name',
            parent_mail: 'Email',
            parent_phone: 'Phone',
            date_of_birth_required: 'To select a package, you must first select the date of birth!',
                age_limit: "You are not old enough to attend the race. ",
            gdpr: 'I accept and agree with <a href="/terms-of-use" class="text-primary" target="_blank"> Terms of Use</a>, <a href="/terms-of-service" class="font__weight-bold" target="_blank">Terms of Service</a>, <a href="/privacy-policy" class="font__weight-bold" target="_blank"> Privacy Policy</a>, <a href="/race-rules" class="font__weight-bold" target="_blank">Race Rules</a>',
            gdpr_josipov: 'I accept and agree with <a href="/doc/pravila-utrke-lokrum.pdf" class="font__weight-bold" target="_blank">Race Rules</a>',
            question: 'Is there any unique information about you and your participation in this event that we may use? Share it with us!',
            disclamer: 'The race registration form must be completed by a person over 18 years of age. For persons under the age of 18, the application is filled out by a parent or a legal guardian.',
            disclamer2: 'Participating runners in Pelješac bridge race must be over 10 years old. Children 10-15 years old can participate only with the presence of the parent also running.',
            already_selected: 'You have already selected package for race',
        },
        newsletter: {
            title: 'DON’T MISS OUT ON ANYTHING!',
            subtitle: 'Sign up for our newsletter today!',
            placeholder: 'Your e-mail',
            gdpr: 'I accept and agree with <a href="/privacy-policy" target="_blank"> Privacy Policy</a>',
            thanks: 'THANK YOU FOR SIGNING UP!'

        },
        pool: {
            title: 'POLL',
            accommodation: 'Accomodation',
            hotel: 'Hotel',
            private: 'Private accomodation',
            camp: 'Camp',
            family: 'Family and friends',
            other: 'Other',
            airplane: 'Airplane',
            boat: 'Boat',
            bus: 'Bus',
            car: 'Car',
        },

        volunteers: {
            first_name: 'Name',
            last_name: 'Surname',
            date_of_birth: 'Date of birth',
            status: 'Status',
            school: 'School / University / Company name',
            note: 'Note',
            note_label: '',
            mail: 'E-mail',
            phone: 'Mobile phone',
            shirt_size: 'T-shirt size',
            volunteer: 'Already volunteered? Name your sector!',
            register: 'Register Now',
            zone: 'Start/finish zone',
            wardrobe: 'Wardrobe',
            expo: 'Expo',
            technical: 'Technical production',
            logistics: 'Logistics',
            station: 'Water stations',
            walls: 'City walls',
            pupil: 'Pupil',
            student: 'Student',
            unemployed: 'Unemployed',
            employed: 'Employed',
            retiree: 'Retiree',
            gdpr: 'I accept and agree with <a href="/privacy-policy" target="_blank"> Privacy Policy</a>',
            thanks1: 'Thank you for registering!',
            thanks2: 'You will receive an e-mail with all the important information shortly.',
            back: 'Back',
            home: 'Home',
            aplication_title1: 'VOLUNTEERS',
            aplication_title2: 'APPLICATION FORM',
            aplication_title3: 'Looking for an amazing volunteer opportunity?',
            aplication_title4: 'Fill out this form and become a Du Motion volunteer!',
            bonus: 'Each volunteer receives an official volunteer t-shirt, a volunteer diploma, a volunteer card with discounts from our partners and refreshment.',
            grade: 'Students from primary and secondary schools must write the grade they are in.',
        },

        payment: {
            currency: 'Pick currency',
            coupon_code: 'Coupon code',
            not_valid: 'Coupon code is not valid!',
            already_applied: 'Coupon code already applied!',
            loading: 'Loading...',
            product: 'Product',
            price: 'Price',
            quantity: 'Quantity',
            total: 'Total',
            pay: 'Pay Now',
            apply: 'Apply',
            subtotal: 'Subtotal',
            discount: 'Discount',
            discount_amount: 'Discount amount',
            total2: 'Total',
            back: 'Continue shopping',
            sold_out_message: 'Unfortunately, all selected products are sold out. Please return to the home page.',
        },

        eval: {
            product_deleted: 'Deleted from cart',
            product_added: 'Added to cart',
            all_fields: 'Fill all required fields!'
        },

        checkout: {
            checkout: 'Checkout',
            process: 'Process',
        },

        coupon: {
            loading: 'Loading...',
            code: 'Enter Coupon Code',
            valid: 'Coupon Successfully Applied!',
            expired: 'Coupon Code Expired',
            not_valid: 'Coupon Code is not valid!',
            already_applied: 'Coupon Code already applied!'
        },

        race_result: {
            select: 'Here you can find all of your hard earned results.',
            select_menu: 'Select your race',
            runner_id: 'Bib number',
            results: 'Get Results',
            result_error: 'Nothing found, please try again!',
            name: 'Name',
            last_name: 'Last Name',
            gender: 'Gender',
            start_num: 'Starting number',
            status: 'Status',
            town: 'Town',
            club: 'Club',
            rank: 'Rank',
            time: 'Time',
            gender: 'Gender',
            result_by_gender: 'Result by gender',
           
        },

        about_us: {
            placeholder: 'How did you hear about us',
            web_site: 'Web site',
            social_network: 'Social networks',
            acquaintance: 'Acquaintance',
            club: 'Club/running school',
            media: 'Media'
        },

        experience: {
            placeholder: 'What would you like to experience',
            wine_routes: 'Wine Routes',
            old_town: 'Old Town',
            dubrvnik_islands: 'Dubrovnik Islands',
            relax: 'Relax and swim',
            gastronomy: 'Gastronomy'
        }
    },
    hr: {

           notification: {
            title: 'OBAVIJEST:',
            description: 'Dostupne liste trkača, važna obavijest o COVID potvrdama',
            read_more: 'SAZNAJ VIŠE...',
            url: '/hr/novosti/dostupne-liste-trkaca-vazna-novost-o-covid-potvrdama',
        },


        registration: {
            euro: "Prijave su tranutno ugašene zbog prelaska na eure. Vraćamo se uskoro!",
            kids_7_9: "Kid's Day (7-9 god)",
            kids_9_11: "Kid's Day (9-11 god)",
            kids_12_14: "Kid's Day (12-14 god)",
            first_name: 'Ime',
            last_name: 'Prezime',
            date_of_birth: 'Datum rođenja',
            gender: 'Spol',
            male: 'Muško',
            female: 'Žensko',
            state: 'Država',
            address: 'Adresa',
            city: 'Grad',
            postal: 'Poštanski broj',
            shirt_size: 'Veličina majice',
            club_name: 'Klub / Škola / Vrtić',
            emergency_contact: 'Broj osobe za nuždu',
            emergency_contact_name: 'Ime osobe za nuždu',
            email: 'Email',
            country_code: 'Pozivni broj',
            phone: 'Telefon',
            chose_ticket: 'Odabir paketa',
            arrival_date: 'Datum dolaska',
            departure_date: 'Datum odlaska',
            transport: 'Način prijevoza',
            accomodation: 'Tip smještaja',
            passengers: 'Broj suputnika',
            note: 'Napomena',
            register: 'Završi prijavu',
            racer: 'ZA TRKAČA',
            no: 'BR.',
            remove: 'Izbriši',
            selected: 'ODABRAN',
            select: 'odaberite',
            package: 'pakete',
            add_racer: 'Dodaj trkača',
            parent_name: 'Ime roditelja',
            parent_lastname: 'Prezime roditelja',
            parent_mail: 'Email',
            parent_phone: 'Telefon',
            date_of_birth_required: 'Kako bi odabrali pakete, potrebno je unijeti datum rođenja trkača!',
            age_limit: "Nemate dovoljno godina za sudjelovanje na utrci.",

            gdpr: 'Slažem se i prihvaćam <a href="/hr/uvjeti-koristenja" target="_blank">Uvjete korištenja</a>, <a href="/hr/opci-uvjeti" target="_blank">Opće uvjete</a>, <a href="/hr/pravila-privatnosti" target="_blank">Pravila Privatnosti</a>, <a href="/hr/pravila-utrke" target="_blank">Pravila Utrke</a>',
            gdpr_josipov: 'Slažem se i prihvaćam <a href="/doc/pravila-utrke-lokrum.pdf" target="_blank">Pravila Utrke</a>',
            question: 'Postoji li neka informacija o vama i vašem sudjelovanju u ovom događaju koja bi nam mogla biti zanimljiva? Podijelite je s nama!',
            disclamer: 'Prijavu za utrku popunjava osoba starija od 18. godina.  Za osobe mlađe od 18. godina prijavu popunjava roditelj odnosno Zakonski staratelj.',
            disclamer2: 'Minimalna dob za prijavu na Utrku Pelješkim mostom je 10 godina. Djeca 10-15 godina starosti mogu sudjelovati isključivo uz prisustvo roditelja trkača.',
            already_selected: 'Već ste odabrali paket za utrku',
        },
        newsletter: {
            kurcina: 'DON’T MISS kurcinu ON ANYTHING!',
            title: 'Neka ti ništa ne promakne!',
            subtitle: 'Pretplati se već danas na naš newsletter!',
            placeholder: 'Tvoj e-mail',
            gdpr: 'Slažem se i prihvaćam <a href="/hr/pravila-privatnosti" target="_blank">Pravila Privatnosti</a>',
            thanks: 'HVALA NA PRIJAVI!'
        },
        pool: {
            title: 'UPITNIK',
            accommodation: 'Smještaj',
            hotel: 'Hotel',
            private: 'Privatni smještaj',
            camp: 'Kamp',
            family: 'Obitelj i prijatelji',
            other: 'Ostalo',
            airplane: 'Avion',
            boat: 'Brod',
            bus: 'Autobus',
            car: 'Auto',
        },

        volunteers: {
            first_name: 'Ime',
            last_name: 'Prezime',
            date_of_birth: 'Datum rođenja',
            status: 'Trenutni status',
            school: 'Naziv škole / fakulteta / tvrtke',
            note: 'Napomena',
            note_label: ' (Postoji li neka informacija o Vama i Vašem sudjelovanju u ovom događaju koje bi nas mogla biti zanimljiva? Podijelite je s nama) ',
            mail: 'E-mail',
            phone: 'Broj mobitela',
            shirt_size: 'Veličina majce',
            volunteer: 'Već si volontirao/la? Navedi u kojem sektoru!',
            register: 'Završi prijavu',
            zone: 'Start/cilj',
            wardrobe: 'Garderoba',
            expo: 'Expo',
            technical: 'Montaža',
            logistics: 'Logistika',
            station: 'Okrijepne stanice',
            walls: 'Zidine',
            pupil: 'Učenik',
            student: 'Student',
            unemployed: 'Nezaposlen',
            employed: 'Zaposlen',
            retiree: 'Umirovljenik',
            gdpr: 'Slažem se i prihvaćam <a href="/hr/pravila-privatnosti" target="_blank">Pravila Privatnosti</a>',
            thanks1: 'Hvala na prijavi!',
            thanks2: 'Ubrzo će na tvoju adresu stići e-mail sa svim važnim informacijama. ',
            back: 'Nazad',
            home: 'Naslovna',
            aplication_title1: 'PRIJAVNICA',
            aplication_title2: 'ZA VOLONTERE',
            aplication_title3: 'Tražiš izvrsnu priliku za volontiranje?',
            aplication_title4: 'Ispuni ovu prijavnicu i postani volonter Du Motiona!',
            bonus: 'Svaki volonter dobija službenu volontersku majicu, volontersku kapu, volontersku diplomu, volontersku karticu s popustima kod naših partnera i okrepu.',
            grade: 'Učenici osnovnih i srednjih škola trebaju upisati razred koji pohađaju.',
        },

        payment: {
            currency: 'Odabir valute',
            product: 'Proizvod',
            price: 'Cijena',
            coupon_code: 'Kupon kod',
            loading: 'Provjeravam...',
            not_valid: 'Kupon kod nije valjan!',
            already_applied: 'Kupon kod je već primjenjen!',
            quantity: 'Komada',
            total: 'Ukupno',
            pay: 'Naplata',
            apply: 'Primjeni',
            subtotal: 'Međusuma',
            discount: 'Popust',
            discount_amount: 'Iznos popusta',
            total2: 'Ukupno',
            back: 'Povratak',
            sold_out_message: 'Nažalost, svi odabrani proizvodi su rasprodani. Molimo vratite se na početnu stranicu.',
        },

        eval: {
            product_deleted: 'Izbrisan iz košarice',
            product_added: 'Dodan u košaricu',
            all_fields: 'Popunite sva obavezna polja!'
        },


        checkout: {
            checkout: 'Pregled',
            process: 'Narudžbe',
        },

        coupon: {
            loading: 'Provjeravam...',
            code: 'Unesi kupon kod!',
            valid: 'Kupon kod uspješno primjenjen!',
            expired: 'Kupon kod je istekao!',
            not_valid: 'Kupon kod nije valjan!',
            already_applied: 'Kupon kod je već primjenjen!'
        },

        race_result: {
            select: 'Ovdje možete pronaći sve svoje hvalevrijedne rezultate!',
            select_menu: 'Izaberi utrku',
            runner_id: 'Startni broj',
            results: 'Pogledaj rezultate',
            result_error: 'Nismo ništa pronašli, molimo Vas pokušajte ponovno!',
            name: 'Ime',
            last_name: 'Prezime',
            gender: 'Spol',
            start_num: 'Početni broj',
            status: 'Status',
            town: 'Grad',
            club: 'Klub',
            rank: 'Rank',
            time: 'Vrijeme',
            gender: 'Spol',
            result_by_gender: 'Rezultat po spolu',
        },

        about_us: {
            placeholder: 'Kako ste saznali za nas',
            web_site: 'Putem web stranica',
            social_network: 'Putem društvenih mreža',
            acquaintance: 'Putem poznanika',
            club: 'Putem kluba/škole trčanja',
            media: 'Putem medija'
        },

        experience: {
            placeholder: 'Što biste željeli doživjeti',
            wine_routes: 'Vinske ceste',
            old_town: 'Stari grad',
            dubrvnik_islands: 'Dubrovačke otoke',
            relax: 'Odmor i kupanje',
            gastronomy: 'Gastronomiju'
        }
    }
}


// Ready translated locale messages
//import messages from './lang/messages'

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: 'en', // set locale
    messages, // set locale messages
})


const app = new Vue({i18n}).$mount('#app')
